import { useEffect } from 'react';
import { PDP_JSON_LD_ID, PDP_SEO_ATTR } from './pdpSeo';

function getOrCreateMetaDescription() {
  const existing = document.head.querySelector('meta[name="description"]');
  if (existing) return { node: existing, created: false };
  const node = document.createElement('meta');
  node.setAttribute('name', 'description');
  document.head.appendChild(node);
  return { node, created: true };
}

export function usePdpSeo(seo) {
  const title = seo?.title || '';
  const metaDescription = seo?.metaDescription || '';
  const canonical = seo?.canonical || '';
  const jsonText = seo?.jsonLd ? JSON.stringify(seo.jsonLd) : '';

  useEffect(() => {
    if (!title || !metaDescription || !canonical || !jsonText) return undefined;

    const previousTitle = document.title;
    document.title = title;

    const { node: meta, created: createdMeta } = getOrCreateMetaDescription();
    const previousDescription = meta.getAttribute('content');
    meta.setAttribute(PDP_SEO_ATTR, 'description');
    meta.setAttribute('content', metaDescription);

    let canonicalNode = document.head.querySelector(
      `link[rel="canonical"][${PDP_SEO_ATTR}="canonical"]`
    );
    if (!canonicalNode) {
      canonicalNode = document.createElement('link');
      canonicalNode.setAttribute('rel', 'canonical');
      canonicalNode.setAttribute(PDP_SEO_ATTR, 'canonical');
      document.head.appendChild(canonicalNode);
    }
    canonicalNode.setAttribute('href', canonical);

    let script = document.getElementById(PDP_JSON_LD_ID);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = PDP_JSON_LD_ID;
      script.setAttribute(PDP_SEO_ATTR, 'jsonld');
      document.head.appendChild(script);
    }
    script.textContent = jsonText;

    return () => {
      document.title = previousTitle;
      if (createdMeta) {
        meta.remove();
      } else if (document.head.contains(meta)) {
        meta.removeAttribute(PDP_SEO_ATTR);
        if (previousDescription != null) meta.setAttribute('content', previousDescription);
        else meta.removeAttribute('content');
      }
      document.head
        .querySelector(`link[rel="canonical"][${PDP_SEO_ATTR}="canonical"]`)
        ?.remove();
      document.getElementById(PDP_JSON_LD_ID)?.remove();
    };
  }, [title, metaDescription, canonical, jsonText]);
}
